import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from "@emm/core/util/api-url.token";
import {Item} from "@emm/core/models/item.model";
import {standardRetry} from "@emm/core/util/rx.util";


@Injectable({
  providedIn: 'root',
})
export class ItemGroupingService {
  constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}

  getAllChildItems(tag: string): Observable<Item[]> {
    return this.http
      .get<{items: Item[] }>(
        this.apiUrl + `/items/children?parent=${tag}&projection=groupingbasics`
      )
      .pipe(
        map((i) => i.items),
        standardRetry()
      );
  }

  getItemGroupings(): Observable<Item[]> {
    return this.http.get<{ items: Item[] }>(`${this.apiUrl}/items/groups`).pipe(
      map((i) => i.items),
      standardRetry()
    );
  }

  // TODO: remove /${false} after backend makes the change to remove deleteGlobal from path variables
  removeChildItem(parentTag: string, childTag: string): Observable<any> {
    return this.http
      .delete(`${this.apiUrl}/items/group/${parentTag}/${childTag}/${false}`)
      .pipe(standardRetry());
  }

  moveItem(parentTag: string, childTag: string, sourceNodeParentTag: string): Observable<any> {
    return this.http
      .post(
        `${this.apiUrl}/items/group/move/${childTag}?fromParent=${sourceNodeParentTag}&toParent=${parentTag}`,
        {}
      )
      .pipe(standardRetry());
  }
}
